import React from 'react';
import {
  Box,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Image,
  HStack,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import brFlag from '../../assets/images/flags/br.svg';
import esFlag from '../../assets/images/flags/es.svg';

// Idioma da empresa (company.language): define o idioma dos e-mails e das
// mensagens da plataforma para os usuários do grupo. No auto-cadastro a empresa
// já nasce com a bandeira escolhida — aqui o consultor pode conferir/editar.
const LANGS = [
  { code: 'pt-BR', flag: brFlag, label: 'Português' },
  { code: 'es', flag: esFlag, label: 'Español' },
];

const flagImg = (src) => (
  <Image
    src={src}
    alt=""
    w="22px"
    h="16px"
    objectFit="cover"
    borderRadius="2px"
    border="1px solid"
    borderColor="gray.200"
  />
);

const FlagSelect = ({ value, onChange, disabled }) => {
  const current = LANGS.find((l) => l.code === value) || LANGS[0];
  return (
    <Menu matchWidth>
      <MenuButton
        as={Button}
        variant="outline"
        isDisabled={disabled}
        h="48px"
        w="100%"
        textAlign="left"
        fontWeight="normal"
      >
        <HStack>
          {flagImg(current.flag)}
          <Text>{current.label}</Text>
        </HStack>
      </MenuButton>
      <MenuList>
        {LANGS.map((l) => (
          <MenuItem key={l.code} onClick={() => onChange(l.code)}>
            <HStack>
              {flagImg(l.flag)}
              <Text>{l.label}</Text>
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

const LanguageField = ({ index, control, disabled }) => (
  <Box maxW="320px">
    <Text fontWeight="600" mb="8px" fontSize="14px" color="#1A202C">
      Idioma da empresa
    </Text>
    <Controller
      name={`form.${index}.language`}
      control={control}
      render={({ field }) => (
        <FlagSelect
          value={field.value || 'pt-BR'}
          onChange={field.onChange}
          disabled={disabled}
        />
      )}
    />
  </Box>
);

export default LanguageField;
